import useIsAuth from 'sdk/hooks/useIsAuth';
import useProfile from 'sdk/hooks/user/useProfile';
import PhoneOrEmail from './PhoneOrEmail';
import BackHeader from 'modules/salon/pages/BackHeader';
import { useNavigate } from 'react-router-dom';
import styles from './SignIn.module.scss';
import SignUpLink from './SignUpLink';

import TermsOfUseLinks from 'components/shared/TermsOfUseLinks';

function SignIn() {
  const navigate = useNavigate();
  const {
    data: { isAuth },
  } = useIsAuth();

  const profileData = useProfile(isAuth);

  if (isAuth && profileData.isSuccess) {
    if (profileData?.data?.username) {
      window.location.href = '/feed';
    } else {
      window.location.href = '/sign-up';
    }
  }

  return (
    <div className={styles.signInWrapper}>
      <BackHeader title="Sign In" onBack={() => navigate(-1)} />
      <div className={styles.container}>
        <PhoneOrEmail />
      </div>
      <div className={styles.footer}>
        <SignUpLink onClick={() => navigate('/sign-up')} />
        <TermsOfUseLinks />
      </div>
    </div>
  );
}

export default SignIn;
